import React from "react";
import { numberToSimpleNumberString } from "../../functions/text-formatting";
import themeColours from "../../functions/get-theme-colours";

export default function ProgressBarList({ data, title }) {
  if (!data) {
    return;
  }

  const BASE_COLOUR_COUNT = 10;

  return (
    <div className="progress-bar-list">
      <div className="progress-bar-list__title">{title}</div>
      {data.map((item, index) => (
        <div className="progress-bar-list__row">
          <div className="progress-bar-list__prelabel">{item.label}</div>
          <div
            className="progress-bar-list__bar"
            style={{
              backgroundColor: themeColours[index % themeColours.length],
            }}
          >
            <div
              className="progress-bar-list__bar__inner"
              style={{
                width: `${(item.value / item.max) * 100}%`,
                backgroundColor:
                  themeColours[
                    (index + BASE_COLOUR_COUNT) % themeColours.length
                  ],
              }}
            />
          </div>
          <div className="progress-bar-list__postlabel">
            {numberToSimpleNumberString(item.value, item.type)}
          </div>
        </div>
      ))}
    </div>
  );
}
